/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import SelectField from "components/SelectField";
import Footer from "./components/footer";

export default function Land02() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const { formId, formField } = form;

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} />
          <Actions />
        </>
      )}
      <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế sử dụng đất nông nghiệp (Mẫu 03/SDDNN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với đất trồng cây lâu năm thu hoạch một lần)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

const cityOption = [
  { value: "cityA", label: "Thành phố A" },
  { value: "cityB", label: "Thành phố B" },
  { value: "cityC", label: "Thành phố C" },
  { value: "cityD", label: "Thành phố D" },
];
const districtOption = [
  { value: "district", label: "Quận A" },
  { value: "district", label: "Quận B" },
  { value: "district", label: "Quận C" },
  { value: "district", label: "Quận D" },
];
const wardOption = [
  { value: "ward", label: "Phường A" },
  { value: "ward", label: "Phường B" },
  { value: "ward", label: "Phường C" },
  { value: "ward", label: "Phường D" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    period,
    exploitationDate,
    firstTime,
    additional,

    taxpayerName,
    dateOfBirth,
    taxId,
    identifier,
    dateRange,
    issuedBy,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    notificationAddress,
    phoneNumber,

    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    plotAddress,
    plotAddressCity,
    plotAddressDistrict,
    plotAddressWard,
    plotAddressVillage,
    plotNumber,
    mapNumber,
    acreage,
    perennialPlant,
    startingTime,
    timeOfAreaChange,

    miningArea,
    catches,
    productSellingPrice,
    valueOfMiningOutput,
    agriculturalLandTax,
    agriculturalLandTaxExemption,
    agriculturalLandUseTax,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={period.name}
            label={period.label}
            error={errors.period && touched.period}
            success={values.period?.toString().length > 0 && !errors.period}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={exploitationDate.name}
            label={exploitationDate.label}
            error={errors.exploitationDate && touched.exploitationDate}
            success={values.exploitationDate?.toString().length > 0 && !errors.exploitationDate}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={additional.name}
            label={additional.label}
            value={values.additional}
            error={errors.additional && touched.additional}
            success={values.additional?.toString().length > 0 && !errors.additional}
          />
        </Grid>
        {/*  */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={dateOfBirth.name}
            label={dateOfBirth.label}
            error={errors.dateOfBirth && touched.dateOfBirth}
            success={values.dateOfBirth?.toString().length > 0 && !errors.dateOfBirth}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={identifier.name}
            label={identifier.label}
            value={values.identifier}
            error={errors.identifier && touched.identifier}
            success={values.identifier?.toString().length > 0 && !errors.identifier}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={dateRange.name}
            label={dateRange.label}
            error={errors.dateRange && touched.dateRange}
            success={values.dateRange?.toString().length > 0 && !errors.dateRange}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={issuedBy.name}
            label={issuedBy.label}
            value={values.issuedBy}
            error={errors.issuedBy && touched.issuedBy}
            success={values.issuedBy?.toString().length > 0 && !errors.issuedBy}
          />
        </Grid>
        {/*  */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            [10] Địa chỉ trụ sở/Địa chỉ cư trú:
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={cityOption}
            type={city.type}
            label={city.label}
            name={city.name}
            value={values.city}
            placeholder={city.placeholder}
            error={errors.city && touched.city}
            success={values.city.length > 0 && !errors.city}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOption}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={wardOption}
            type={ward.type}
            label={ward.label}
            name={ward.name}
            value={values.ward}
            placeholder={ward.placeholder}
            error={errors.ward && touched.ward}
            success={values.ward.length > 0 && !errors.ward}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={village.name}
            label={village.label}
            value={values.village}
            error={errors.village && touched.village}
            success={values.village?.toString().length > 0 && !errors.village}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={road.name}
            label={road.label}
            value={values.road}
            error={errors.road && touched.road}
            success={values.road?.toString().length > 0 && !errors.road}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={apartment.name}
            label={apartment.label}
            value={values.apartment}
            error={errors.apartment && touched.apartment}
            success={values.apartment?.toString().length > 0 && !errors.apartment}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={notificationAddress.name}
            label={notificationAddress.label}
            value={values.notificationAddress}
            error={errors.notificationAddress && touched.notificationAddress}
            success={
              values.notificationAddress?.toString().length > 0 && !errors.notificationAddress
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={phoneNumber.name}
            label={phoneNumber.label}
            value={values.phoneNumber}
            error={errors.phoneNumber && touched.phoneNumber}
            success={values.phoneNumber?.toString().length > 0 && !errors.phoneNumber}
          />
        </Grid>
        {/*  */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            2. Đại lý thuế (nếu có):
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentContract.name}
            label={taxAgentContract.label}
            value={values.taxAgentContract}
            error={errors.taxAgentContract && touched.taxAgentContract}
            success={values.taxAgentContract?.toString().length > 0 && !errors.taxAgentContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={daytaxAgentContract.name}
            label={daytaxAgentContract.label}
            value={values.daytaxAgentContract}
            error={errors.daytaxAgentContract && touched.daytaxAgentContract}
            success={
              values.daytaxAgentContract?.toString().length > 0 && !errors.daytaxAgentContract
            }
          />
        </Grid>
        {/*  */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            3. Thửa đất chịu thuế, loại cây:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={plotAddress.name}
            label={plotAddress.label}
            value={values.plotAddress}
            error={errors.plotAddress && touched.plotAddress}
            success={values.plotAddress?.toString().length > 0 && !errors.plotAddress}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={cityOption}
            type={plotAddressCity.type}
            label={plotAddressCity.label}
            name={plotAddressCity.name}
            value={values.plotAddressCity}
            placeholder={plotAddressCity.placeholder}
            error={errors.plotAddressCity && touched.plotAddressCity}
            success={values.plotAddressCity.length > 0 && !errors.plotAddressCity}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOption}
            type={plotAddressDistrict.type}
            label={plotAddressDistrict.label}
            name={plotAddressDistrict.name}
            value={values.plotAddressDistrict}
            placeholder={plotAddressDistrict.placeholder}
            error={errors.plotAddressDistrict && touched.plotAddressDistrict}
            success={values.plotAddressDistrict.length > 0 && !errors.plotAddressDistrict}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={wardOption}
            type={plotAddressWard.type}
            label={plotAddressWard.label}
            name={plotAddressWard.name}
            value={values.plotAddressWard}
            placeholder={plotAddressWard.placeholder}
            error={errors.plotAddressWard && touched.plotAddressWard}
            success={values.plotAddressWard.length > 0 && !errors.plotAddressWard}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={plotAddressVillage.name}
            label={plotAddressVillage.label}
            value={values.plotAddressVillage}
            error={errors.plotAddressVillage && touched.plotAddressVillage}
            success={values.plotAddressVillage?.toString().length > 0 && !errors.plotAddressVillage}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={plotNumber.name}
            label={plotNumber.label}
            value={values.plotNumber}
            error={errors.plotNumber && touched.plotNumber}
            success={values.plotNumber?.toString().length > 0 && !errors.plotNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={mapNumber.name}
            label={mapNumber.label}
            value={values.mapNumber}
            error={errors.mapNumber && touched.mapNumber}
            success={values.mapNumber?.toString().length > 0 && !errors.mapNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={acreage.name}
            label={acreage.label}
            value={values.acreage}
            error={errors.acreage && touched.acreage}
            success={values.acreage?.toString().length > 0 && !errors.acreage}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={perennialPlant.name}
            label={perennialPlant.label}
            value={values.perennialPlant}
            error={errors.perennialPlant && touched.perennialPlant}
            success={values.perennialPlant?.toString().length > 0 && !errors.perennialPlant}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={startingTime.name}
            label={startingTime.label}
            error={errors.startingTime && touched.startingTime}
            success={values.startingTime?.toString().length > 0 && !errors.startingTime}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={timeOfAreaChange.name}
            label={timeOfAreaChange.label}
            error={errors.timeOfAreaChange && touched.timeOfAreaChange}
            success={values.timeOfAreaChange?.toString().length > 0 && !errors.timeOfAreaChange}
          />
        </Grid>
        {/*  */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            4. Tính thuế:
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={miningArea.name}
            label={miningArea.label}
            value={values.miningArea}
            error={errors.miningArea && touched.miningArea}
            success={values.miningArea?.toString().length > 0 && !errors.miningArea}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={catches.name}
            label={catches.label}
            value={values.catches}
            error={errors.catches && touched.catches}
            success={values.catches?.toString().length > 0 && !errors.catches}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={productSellingPrice.name}
            label={productSellingPrice.label}
            value={values.productSellingPrice}
            error={errors.productSellingPrice && touched.productSellingPrice}
            success={
              values.productSellingPrice?.toString().length > 0 && !errors.productSellingPrice
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            style={{}}
            name={valueOfMiningOutput.name}
            label={valueOfMiningOutput.label}
            value={values.valueOfMiningOutput}
            error={errors.valueOfMiningOutput && touched.valueOfMiningOutput}
            success={
              values.valueOfMiningOutput?.toString().length > 0 && !errors.valueOfMiningOutput
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agriculturalLandTax.name}
            label={agriculturalLandTax.label}
            value={values.agriculturalLandTax}
            error={errors.agriculturalLandTax && touched.agriculturalLandTax}
            success={
              values.agriculturalLandTax?.toString().length > 0 && !errors.agriculturalLandTax
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agriculturalLandTaxExemption.name}
            label={agriculturalLandTaxExemption.label}
            value={values.agriculturalLandTaxExemption}
            error={errors.agriculturalLandTaxExemption && touched.agriculturalLandTaxExemption}
            success={
              values.agriculturalLandTaxExemption?.toString().length > 0 &&
              !errors.agriculturalLandTaxExemption
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={agriculturalLandUseTax.name}
            label={agriculturalLandUseTax.label}
            value={values.agriculturalLandUseTax}
            error={errors.agriculturalLandUseTax && touched.agriculturalLandUseTax}
            success={
              values.agriculturalLandUseTax?.toString().length > 0 && !errors.agriculturalLandUseTax
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
